export const PurchaseOrderItemsSupplierPage = () => {
  return <>PurchaseOrderItemsSupplierPage</>;
};
